<lib-message [type]="'tip'" [dismissId]="'broadcastChatInfo'" class="push-bottom">
	<div>Broadcast is a feature that allows you to send a message to all your clients at once.</div>
</lib-message>

@for (client of clients(); track client.id; let first = $first) { }

<lib-card>
	<div>
		<ui-text-area-form-field
			[placeholder]="'Type a message'"
			[valueAsSignal]="message"
			[enableEmoji]="true"
			[enableGenAi]="true"
		></ui-text-area-form-field>
	</div>
	<div class="push-top">
		<ui-form-save-button
			[removeDivider]="true"
			[title]="'Send'"
			[saveHandler]="saveHandler()"
			[logHandler]="formLogHandler()"
			[enableControlEnterSaveShortcut]="true"
		></ui-form-save-button>
	</div>
</lib-card>

<lib-card [title]="'Message will be sent to all these clients'" class="push-top-md">
	<div [libFlexRow]="true" [libFlexRowGap]="'16px'">
		@for (client of clients(); track client.id; let first = $first) {
		<div libFlexColumn [libFlexSize]="'50px'">
			<lib-image
				[libTooltip]="client.fullName"
				[isResponsive]="true"
				[image]="client.avatar"
				[avatarName]="client.fullName"
				[alt]="'Avatar'"
				[imageSize]="'50px'"
			></lib-image>
		</div>
		}
	</div>
</lib-card>
